export default __webpack_public_path__ + "static/media/illustration-study-1-w@3x.b75884ed.webp";